import React, { useState, useEffect } from "react";
import culturalBackgroundOptions from "./data/culturalBackgroundOptions.json";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const CulturalBackgroundComponent = ({ user }) => {
  const [culturalBackgrounds, setCulturalBackgrounds] = useState(
    culturalBackgroundOptions.culturalBackgrounds.map((background) => ({
      text: background,
      isSelected: false,
    }))
  );
  const [validationError, setValidationError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    if (user && user.id) {
      const fetchCulturalBackgrounds = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const userCulturalBackgrounds = fetchedUserData.culturalBackground;

          const updatedCulturalBackgrounds = culturalBackgrounds.map(
            (background) => ({
              ...background,
              isSelected: userCulturalBackgrounds.includes(background.text),
            })
          );

          setCulturalBackgrounds(updatedCulturalBackgrounds);
        } catch (error) {
          console.error("Failed to fetch cultural background data:", error);
        }
      };

      fetchCulturalBackgrounds();
    }
  }, [user, baseURL]);

  const toggleCulturalBackgroundSelection = (index) => {
    const newBackgrounds = [...culturalBackgrounds];
    newBackgrounds[index].isSelected = !newBackgrounds[index].isSelected;
    setCulturalBackgrounds(newBackgrounds);
    setValidationError("");
  };

  const handleSave = async () => {
    setValidationError("");

    const isAnyBackgroundSelected = culturalBackgrounds.some(
      (background) => background.isSelected
    );

    if (!isAnyBackgroundSelected) {
      setValidationError("Please select at least one cultural background.");
      return;
    }

    const selectedCulturalBackgrounds = culturalBackgrounds
      .filter((bg) => bg.isSelected)
      .map((bg) => bg.text);

    const culturalBackgroundData = {
      culturalBackground: selectedCulturalBackgrounds,
    };

    console.log(
      "Selected cultural backgrounds for Patching:",
      culturalBackgroundData
    );

    try {
      const response = await axios.patch(
        `${baseURL}/v1/worker-users/${user.id}`,
        culturalBackgroundData
      );

      if (response.data) {
        console.log("Cultural Background Patch successful");
        setShowModal(true);
      }
    } catch (error) {
      console.error("Failed to update cultural background selections", error);
      setValidationError("Failed to update. Please try again.");
    }
  };

  return (
    <div className="cultural-background-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="cultural-background-indicative-above-div">
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Cultural background</h2>
        </div>
        
        <p>
        Select your cultural background to support better client matches.
        </p>
      </div>

      <div className="cultural-background-buttons-container">
        {culturalBackgrounds.map((background, index) => (
          <button
            key={background.text}
            className={`cultural-background-horizontal-button ${
              background.isSelected ? "selected" : ""
            }`}
            onClick={() => toggleCulturalBackgroundSelection(index)}
          >
            <div className="button-checkmark">
              {background.isSelected ? "✓" : ""}
            </div>
            <div className="button-text">{background.text}</div>
          </button>
        ))}
      </div>
      {validationError && (
        <div className="cultural-background-error">{validationError}</div>
      )}
      <div className="cultural-background-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default CulturalBackgroundComponent;
